document.addEventListener("DOMContentLoaded", () => {
  const productCustomizationContainer = document.querySelector(
    ".product-customization-container",
  );
  if (!productCustomizationContainer) return;

  const addToCartButton = productCustomizationContainer
    .closest(".product-info__block-list")
    .querySelector('button[type="submit"]');
  const customizationOptionButtonList =
    productCustomizationContainer.querySelectorAll(
      ".customization-option-button",
    );
  const customizationPreviewWrapperList =
    productCustomizationContainer.querySelectorAll(
      ".customization-preview-wrapper",
    );

  productCustomizationContainer.addEventListener("click", (event) => {
    const eventPath = event.composedPath
      ? event.composedPath().slice(0, -2)
      : [];

    for (const element of eventPath) {
      const clickAction = element?.getAttribute("data-click-action");
      if (!clickAction) continue;

      if (clickAction === "update-customization-option") {
        updateCustomizationOption(element);
        break;
      } else if (clickAction === "update-customization-color") {
        updateCustomizationColor(element);
        break;
      }
    }
  });

  productCustomizationContainer.addEventListener("input", (event) => {
    const eventPath = event.composedPath
      ? event.composedPath().slice(0, -2)
      : [];

    for (const element of eventPath) {
      const inputAction = element?.getAttribute("data-input-action");
      if (!inputAction) continue;

      if (inputAction === "update-customization-preview") {
        updateCustomizationPreview(element);
        break;
      }
    }
  });

  function updateCustomizationOption(customizationOptionButton) {
    const activeButton = customizationOptionButton.hasAttribute("data-active");

    customizationOptionButtonList.forEach((button) => {
      button.removeAttribute("data-active");
    });
    customizationPreviewWrapperList.forEach((previewWrapper) => {
      previewWrapper.removeAttribute("data-active");
    });

    const customizationOptionHandle =
      customizationOptionButton.getAttribute("data-option-handle");
    const associatedCustomizationPreviewWrapper =
      productCustomizationContainer.querySelector(
        `.customization-preview-wrapper[data-option-handle="${customizationOptionHandle}"]`,
      );

    if (!activeButton) {
      customizationOptionButton.setAttribute("data-active", "");
      associatedCustomizationPreviewWrapper.setAttribute("data-active", "");
    }

    updateAddToCartCustomizationData();
  }

  function updateCustomizationPreview(customizationPreviewInput) {
    const customizationPreviewText =
      customizationPreviewInput?.nextElementSibling;
    if (
      customizationPreviewText &&
      customizationPreviewText?.classList.contains("customization-preview-text")
    ) {
      customizationPreviewText.textContent = customizationPreviewInput.value;
    }

    updateAddToCartCustomizationData();
  }

  const colorCustomizationImageCache = {};

  function updateAddToCartCustomizationData() {
    const selectedCustomizationOption =
      productCustomizationContainer.querySelector(
        ".customization-option-button[data-active]",
      );
    if (!selectedCustomizationOption) {
      addToCartButton.removeAttribute("data-customization");
      addToCartButton.removeAttribute("data-customization-color");
      return;
    }

    const customizationVariantId =
      selectedCustomizationOption.getAttribute("data-variant-id");

    const previewWrapper = productCustomizationContainer.querySelector(
      `.customization-preview-wrapper[data-active]`,
    );
    const customizationInput = previewWrapper?.querySelector(
      ".customization-preview-input",
    );

    const customizationInputValue = customizationInput
      ? encodeURI(customizationInput.value)
      : selectedCustomizationOption.getAttribute("data-option-title");

    const customizationData = `${customizationVariantId}:${customizationInputValue}`;

    addToCartButton.setAttribute("data-customization", customizationData);

    const customizationColor = previewWrapper
      ?.querySelector(".customization-color-button[data-active]")
      ?.getAttribute("data-color-name");
    if (!customizationColor) {
      addToCartButton.removeAttribute("data-customization-color");
    } else {
      addToCartButton.setAttribute(
        "data-customization-color",
        encodeURI(customizationColor),
      );

      const currentPreviewImage = previewWrapper.querySelector("img");
      const activeColorButton = previewWrapper.querySelector(
        ".customization-color-button[data-active]",
      );
      const baseImageSource = activeColorButton.getAttribute(
        "data-base-image-source",
      );
      const colorImageSource = activeColorButton.getAttribute(
        "data-color-image-source",
    );

    if (colorCustomizationImageCache[colorImageSource]) {
        currentPreviewImage.setAttribute("src", colorImageSource);
        previewWrapper.setAttribute("data-colored-image", "");
    } else {
        fetch(colorImageSource)
            .then((response) => {
                if (response.ok) {
                  colorCustomizationImageCache[colorImageSource] = true;
                    currentPreviewImage.setAttribute("src", colorImageSource);
                    previewWrapper.setAttribute("data-colored-image", "");
                } else {
                    currentPreviewImage.setAttribute("src", baseImageSource);
                    previewWrapper.removeAttribute("data-colored-image");
                }
            })
            .catch(() => {
                currentPreviewImage.setAttribute("src", baseImageSource);
                previewWrapper.removeAttribute("data-colored-image");
            });
    }
    }
  }

  function updateCustomizationColor(element) {
    if (element.hasAttribute("data-active")) return;

    const colorCode = element.getAttribute("data-color-code");

    const previewWrapper = element.closest(".customization-preview-wrapper");
    previewWrapper.style.setProperty("--customization-color", colorCode);

    const colorButtons = element
      .closest(".customization-color-list")
      .querySelectorAll(".customization-color-button");
    colorButtons.forEach((button) => button.removeAttribute("data-active"));
    element.setAttribute("data-active", "");

    updateAddToCartCustomizationData();
  }
});
